/**
 * The sentence a usage card shows when a refresh fails.
 *
 * The Shell answers a failed Claude refresh with a closed set of codes
 * (`apps/server/src/command/claudeUsageRefreshFailure.ts`). Anything outside
 * that set, including every Codex failure and a code a newer Shell may send to
 * an older client, keeps the original generic line, so a card never renders a
 * blank explanation.
 */
const GENERIC_FAILURE = "Refresh failed. Showing the last known values.";

const COPY_BY_CODE: Record<string, string> = {
  CLAUDE_USAGE_ENVIRONMENT_UNAVAILABLE:
    "Refresh needs your Environment running. Showing the last known values.",
  CLAUDE_USAGE_CREDENTIAL_NOT_READY:
    "The Claude credential is not applied to your Environment yet. Showing the last known values.",
  CLAUDE_USAGE_REFRESH_IN_PROGRESS:
    "A refresh for this account is already running. Try again in a moment.",
  CLAUDE_USAGE_PROBE_FAILED:
    "Your Environment could not read Claude usage. Showing the last known values.",
  CLAUDE_USAGE_RECONNECT_REQUIRED:
    "Reconnect this Claude account to refresh usage. Showing the last known values.",
  CLAUDE_USAGE_ACCOUNT_NOT_FOUND:
    "This Claude account is no longer connected. Showing the last known values.",
  CLAUDE_USAGE_CREDENTIAL_APPLY_FAILED:
    "Your Environment rejected the delivered Claude credential. " +
    "Reconnect Claude to send a new one.",
  CLAUDE_USAGE_CREDENTIAL_REFRESHING:
    "The delivered Claude credential expired. " +
    "CMMD is sending a replacement, so try again in a moment.",
};

export function formatProviderUsageRefreshFailure(code: string | null): string {
  if (code === null || !Object.hasOwn(COPY_BY_CODE, code)) return GENERIC_FAILURE;
  return COPY_BY_CODE[code] ?? GENERIC_FAILURE;
}
